<template>
    <v-stepper v-model="currentStep" class="estilo_pasos secondary lighten-4">
        <v-stepper-header>
            <v-stepper-step
                :complete="currentStep > 1"
                step="1"
            >
                Trámite a Pagar
            </v-stepper-step>

            <v-stepper-step
                :complete="currentStep > 2"
                step="2"
            >
                Datos Fiscales
            </v-stepper-step>

            <v-stepper-step
                :complete="currentStep > 3"
                step="3"
            >
                Proceso de pago
            </v-stepper-step>

            <v-stepper-step 
                :complete="currentStep > 4"
            step="4">
                Finalizado
            </v-stepper-step>

        </v-stepper-header>
    </v-stepper>
</template>

<script>
    export default {
        name: 'Portofoliosteps',
        props: ['currentStep']
    };
</script>

<style scoped>
    .estilo_pasos{
        top: -22px;
        margin-left: -22px;
        margin-right: -22px;
        border-radius: 0px;
        box-shadow: none;
    }

    .estilo_pasos .v-stepper__header{
        height: auto;
        justify-content: center;
    }

    .estilo_pasos .v-stepper__step{
        padding: 10px 15px 10px 15px;
    }

    .estilo_pasos .v-stepper__step--active{
        background-color: #FFFFFF;
    }

    .estilo_pasos .v-stepper__step:after {
        content: "";
        position: absolute;
        z-index: 6;
        top: 0px;
        left: 100%;
        width: 0px;
        height: 0;
        border-left: 7px;
        border-top: 21px;
        border-bottom: 21px;
        border-style: solid;
        border-color: transparent transparent transparent var(--v-secondary-lighten4);
    }


    .estilo_pasos .v-stepper__step--active:after {
        content: "";
        position: absolute;
        z-index: 5;
        top: 0px;
        left: 100%;
        width: 0px;
        height: 0;
        border-left: 5px;
        border-top: 22px;
        border-bottom: 22px;
        border-style: solid;
        border-color: transparent transparent transparent #FFFFFF;
    }

    .estilo_pasos .v-stepper__step--active:before {
        content: none;
    }

    .estilo_pasos .v-stepper__step--active ~ .v-stepper__step:after {
        content: "";
        position: absolute;
        z-index: 5;
        top: 0px;
        left: 101%;
        width: 0px;
        height: 0;
        border-left: 5px;
        border-top: 22px;
        border-bottom: 22px;
        border-style: solid;
        border-color: transparent transparent transparent #FFFFFF;
    }

    .estilo_pasos .v-stepper__step--active ~ .v-stepper__step:before {
        content: "";
        position: absolute;
        z-index: 6;
        top: 0px;
        left: 100%;
        width: 0px;
        height: 0;
        border-left: 5px;
        border-top: 22px;
        border-bottom: 22px;
        border-style: solid;
        border-color: transparent transparent transparent var(--v-secondary-lighten4);
    }

    .estilo_pasos .v-stepper__step--active ~ .v-stepper__step:last-of-type:before {
        content: none;
    }

    .estilo_pasos .v-stepper__step--active ~ .v-stepper__step:last-of-type:after {
        content: none;
    }


</style>